import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, computedFrom } from "aurelia-framework";
import { InspectionStateEnum } from '../../models/rightship-inspections/rightship-inspections.models';
import * as moment from "moment";
import { UserClaimsService } from '../../services/basic/user-claims.service';
import { Claims } from '../../constants/authentication/claims';
import { SafetyRatingTypeEnum } from '../../models/vessels/vessel.models';
import { Messages } from '../../constants/event-messages.constants';
import { IncidentGracePeriod } from '../../models/incidents/incident.models';
import type { DocSubscoreGracePeriod } from '../../models/companies/company.models';

//Load styles
require("./comp-safety-score.scss");

@autoinject
export class CompSafetyScore {

 	@bindable
    showSafetyScore: boolean;
    
    @bindable
    isCondensed: boolean;
    
    @bindable
    showWarnings: boolean = true;

    @bindable
    score: string;

    @bindable
    isSanctionedOrGeopoliticalZoneOrFlagFake: boolean;

    @bindable
    inspection?: {
        inspectionState: InspectionStateEnum;
        rightShipInspectionExpiryDate?: Date;
        systemRuleLastExecutedStatus: string;
        asOf?:Date;
    } = { inspectionState: InspectionStateEnum.None, systemRuleLastExecutedStatus: null, asOf: null };

    @bindable
    safetyScoreType: number;

    @bindable
    safetyRatingIndicative: boolean;

    @bindable
    hasError: string;

    @bindable
    showTooltip: boolean = true;

    @bindable
    enlarged: boolean = false;

    @bindable
    isDocSubscore: boolean = false;

    @bindable
    maskData: boolean = false;

    @bindable
    lockedFeature: boolean = false;

    @bindable
    unlockFeatureKey: string;

    @bindable
    incidentGracePeriods: IncidentGracePeriod[];

    @bindable
    docSubscoreGracePeriod: DocSubscoreGracePeriod;

    @bindable
    docSubscoreWarning: boolean;

    @bindable
    hasDocHybridRule: boolean;

    @bindable
    docHybridRuleText: string;

    isCustomer: boolean;
    na: number = SafetyRatingTypeEnum.NA;
    fullScore: number = SafetyRatingTypeEnum.FullScore;
    score0: number = SafetyRatingTypeEnum.Score0;
    score1: number = SafetyRatingTypeEnum.Score1;
    score2: number = SafetyRatingTypeEnum.Score2;
    inspectionStateNone = InspectionStateEnum.None;
    inspectionStateValid = InspectionStateEnum.Valid;
    inspectionStateExpiring = InspectionStateEnum.Expiring;
    inspectionStateRequired = InspectionStateEnum.Required;

    constructor(userClaimsService: UserClaimsService, private eventAggregator: EventAggregator) {
        if (this.showSafetyScore == null || this.showSafetyScore == undefined) {
            this.showSafetyScore = userClaimsService.hasPermission(Claims.ShowSafetyScore);
        }

        if (this.hasDocHybridRule) {
            this.hasDocHybridRule = this.hasDocHybridRule && userClaimsService.hasPermission(Claims.CanAccessDOCSubscoreHybridRules);
        }

        this.isCustomer = !userClaimsService.hasPermission(Claims.RightShipUser);
    }

    @computedFrom('inspection')
    get inspectionVisible() {
        return this.inspection?.inspectionState != InspectionStateEnum.None && this.inspection?.inspectionState != InspectionStateEnum.WillRequire;
    }

    @computedFrom('inspection')
    get daysRemaining() {
        if (this.inspection && this.inspection.rightShipInspectionExpiryDate) {
            let asOf = this.inspection.asOf? moment(this.inspection.asOf): moment();
            
            return moment(this.inspection.rightShipInspectionExpiryDate).add(new Date().getTimezoneOffset() / 60, "hours").diff(asOf, 'day');
        }
        return null;
    }

    unlockFeature() {
        if (this.lockedFeature === true) {
            this.eventAggregator.publish(Messages.unlockFeature, this.unlockFeatureKey);
        }
    }

    remainingGracePeriodDate(remainingGracePeriodDays: number){
        let today = new Date();
        
        //Add the remaining grace period days to today's date
        today.setDate(today.getDate() + remainingGracePeriodDays);
        
        let newDate = moment(today).format("DD MMM YYYY");

        return newDate;
    }
}